import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1228211e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("发票 "),
  /*#__PURE__*/_createElementVNode("i", { class: "require-icon" })
], -1))
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "color-gray" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"cell-item\" data-v-1228211e><div class=\"label\" data-v-1228211e>支付方式</div><div class=\"value\" data-v-1228211e><img src=\"/images/wxpay.svg\" data-v-1228211e><span class=\"wx-pay-text\" data-v-1228211e>微信支付</span></div></div>", 1)
const _hoisted_7 = {
  key: 0,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_8 = { class: "form-content xag-flex-center" }
const _hoisted_9 = { class: "price-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "合计金额：", -1))
const _hoisted_11 = { class: "price-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-unit" }, "￥", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, computed, ComputedRef } from 'vue'
import appHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import {
  PayDetailItem,
  RecordDetailKeyDetail,
  RecordDetailReduceDetail,
  SubmitRestMoneyPayParams,
} from '@/types/device-replace-v3'
import {
  getApplyRecordDetail,
  submitPayRestMoney,
  checkPayOrderStatus,
} from '@/apis/device-replace-v3'
import { Button, Dialog } from 'vant'
import { useRouter, Router } from 'vue-router'
import getRoute from '@/compositions/route'
import ProductWrapper from './components/record-product-block.vue'
import {
  showToastLoading,
  showConfirmModal,
  showToastFail,
  clearToast,
  showToastSuccess,
} from '@/utils/tools'
import { confirmUseInvoiceStorageKey } from '@/views/invoice/definition'
import { InvoiceItem } from '@/types/invoice'
import { isApp } from '@/utils/app'
import type { CommonUploaderFileListItem } from '@/types/public'


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-rest-money',
  setup(__props) {

const $router: Router = useRouter()
const { query } = getRoute()
const guid = (query.value.guid as string) || ''
const currentSource = isApp ? 'app' : 'mini' // app/小程序
let onLeftClick = function () {
  // 移除已选的发票信息?
  $router.replace({
    name: 'device-replace-v3-record-detail',
    query: {
      guid,
    },
  })
}

const frontPrice = 1000
const restMoney = computed(() => {
  return (detail.value.price - frontPrice).toFixed(2) || 0
})
// 待支付尾款payInfo
const payRestInfo = computed(() => {
  const payInfo: PayDetailItem | undefined =
    detail.value.pay_detail.find((info: PayDetailItem) => {
      return info.type === 2 // 筛选出尾款的支付信息
    }) || undefined
  if (payInfo && payInfo.status === 1) {
    return payInfo
  }
  return null
})

const isInited = ref(false)
const detail = ref(null)
async function fetchRecordDetail() {
  showToastLoading({
    message: '加载中...',
  })
  try {
    let data = await getApplyRecordDetail({ guid })
    let childProductMap = data.detail.reduce(
      (result: RecordDetailReduceDetail, item: RecordDetailKeyDetail) => {
        let current = result[item.exchange_product_code]
        if (current) {
          current.count++
        } else {
          result[item.exchange_product_code] = {
            child_product_guid: '',
            count: 1,
            guid: item.exchange_product_guid,
            images: item.images,
            is_main: 1,
            name: item.exchange_product_name,
            price: 0,
            product_guid: '',
            tax_rate: 0,
          }
        }
        return result
      },
      {}
    )
    detail.value = data
    detail.value.new_product_child = Object.keys(childProductMap).map((key) => childProductMap[key])
  } catch (error) {}
  isInited.value = true
  clearToast()
}

// 发票相关信息
// 以及换新开票新增： email邮件地址 & file待付款证明

let needInvoice = true
let invoice: InvoiceItem = null
let email = ''
let certificate = ''
let invoiceHeader = ''
const invoiceStr: ComputedRef<string> = computed(() => {
  if (needInvoice === false) {
    // 不开发票
    return '不开发票'
  } else if (needInvoice === true) {
    return invoiceHeader
  }
  return ''
})
// 是否专票
const isVatSpecialInvoice: ComputedRef<boolean> = computed(() => {
  return needInvoice && invoice.invoice_type === 1
})
function toSelectInvoice() {
  $router.push({
    name: 'invoice-confirm-qd',
    query: {
      needInvoice: 1,
    },
  })
}

// 轮询支付结果
let timeId: number
function handleSearchOrderPayStatus(pay_order_no: string, immediately = false) {
  // 查询单据支付状态
  let i = 0
  let searching = false
  function handleFn() {
    showToastLoading({
      message: '支付结果查询中',
    })
    if (i >= 12) {
      clearInterval(timeId)
      clearToast()
      Dialog.confirm({
        title: '查询结果失败',
        message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
        confirmButtonText: '重新查询',
        cancelButtonText: '取消查询',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            handleSearchOrderPayStatus(pay_order_no, true)
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    if (searching) {
      return
    }
    searching = true
    checkPayOrderStatus({ order_no: pay_order_no })
      .then((result) => {
        console.log('查询支付结果', result)
        if (result.status === 2) {
          // status:1-待付款 2-已付款 3-退回
          clearToast()
          // 跳转到支付成功页面
          clearInterval(timeId)
          showToastSuccess('支付成功')
          setTimeout(() => {
            $router.replace({
              name: 'device-replace-v3-record-detail',
              query: {
                guid,
              },
            })
          }, 500)
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        searching = false
        i++
      })
  }
  if (immediately) {
    handleFn()
  }
  //
  timeId = setInterval(async () => {
    // 如果查询时间超过1分钟 那么停止查询并提示
    handleFn()
  }, 5000)
}
const canComfirm: ComputedRef<boolean> = computed(() => {
  return !!invoiceHeader
})
async function sumbit() {
  // 判断是否已创建付款单创建
  // 已创建 需要判断渠道与当前是否一致
  console.log('待支付尾款信息：', payRestInfo.value, currentSource)
  if (payRestInfo.value && payRestInfo.value.source && payRestInfo.value.source !== currentSource) {
    return Dialog.confirm({
      message: `请到${
        payRestInfo.value.source === 'app' ? '极飞农服APP端' : '极飞服务小程序'
      }完成支付`,
      confirmButtonText: '我知道了',
      className: 'repair-dialog',
      width: 304,
    })
  }
  // 确认支付
  let parameter: SubmitRestMoneyPayParams = {
    guid: guid, //申请单guid
    payment: 'wx',
    source: currentSource, //app/小程序
  }
  if (!invoiceHeader) {
    showToastFail('请填写发票信息')
    return
  }
  if (needInvoice) {
    parameter.invoice_guid = invoice.guid
    // 提交参数里的 invoice_type和发票信息里的invocie_type 并不是同一个概念, 这里需要对应的转化 普票0 -> 3; 专票 1 -> 4
    // 提交参数里的 invoice_apply_type = 发票信息里的invocie_type  0 普票 1 专票
    let invoiceType = invoice.invoice_type
    if (invoiceType === 0) {
      parameter.invoice_type = 3
      parameter.invoice_apply_type = 0
    } else if (invoiceType === 1) {
      parameter.invoice_type = 4
      parameter.invoice_apply_type = 1
    }
    // 以旧换新三期 补充发票收件邮箱 & 待付款证明
    parameter.email = email
    parameter.certificate = certificate
  }
  console.log('支付尾款', parameter)
  try {
    // 确定支付尾款获取pay_no
    await showConfirmModal({ title: '是否确认支付' })
    try {
      let payOrderNo
      if (payRestInfo.value && payRestInfo.value.pay_no) {
        payOrderNo = payRestInfo.value.pay_no
      } else {
        let data = await submitPayRestMoney(parameter)
        payOrderNo = data.order_no
      }
      appHost.onPay(payOrderNo) // 调用app支付
      handleSearchOrderPayStatus(payOrderNo)
    } catch (error) {
      console.log('订单申请失败-error', error)
      let message = error && error.message ? error.message : '申请失败'
      Dialog({
        message,
        confirmButtonText: '我知道了',
        className: 'repair-dialog',
        width: 304,
      })
    }
  } catch (error) {
    console.log('取消支付')
  }
}
async function initPageData() {
  const invoiceInfoJSON = sessionStorage.getItem(confirmUseInvoiceStorageKey)
  if (invoiceInfoJSON) {
    let invoiceInfo = JSON.parse(invoiceInfoJSON)
    console.log('confirmUseInvoice', invoiceInfo)
    needInvoice = invoiceInfo.needInvoice
    if (needInvoice) {
      let invoiceCache = invoiceInfo.invoice
      invoiceHeader = invoiceCache.header
      invoice = invoiceCache
      email = invoiceInfo.email // 邮箱
      if (isVatSpecialInvoice.value) {
        // 专票
        let fileArray = invoiceInfo.certificate.map((file: CommonUploaderFileListItem) => {
          // 待付款证明
          return file.url
        })
        certificate = fileArray.join(',')
      }
    }
  }
  fetchRecordDetail()
}

const popupsShow = ref(false)
function onUpdatePopupShow(show: boolean) {
  popupsShow.value = show
}

initPageData()

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      title: "支付尾款",
      isReturnLeftEvent: "",
      onLeftClick: _unref(onLeftClick)
    }, null, 8, ["onLeftClick"]),
    (isInited.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(ProductWrapper, {
              title: detail.value.client_name,
              productName: detail.value.new_product.name,
              productImages: detail.value.new_product.images,
              productChild: detail.value.new_product_child,
              payStatus: detail.value.pay_status,
              price: detail.value.price,
              mode: 'pay',
              onUpdatePopupShow: onUpdatePopupShow
            }, null, 8, ["title", "productName", "productImages", "productChild", "payStatus", "price"]),
            _createElementVNode("div", {
              class: "cell-item",
              onClick: toSelectInvoice
            }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(invoiceStr)), 1),
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  class: "arrow-item"
                })
              ])
            ]),
            _hoisted_6
          ]),
          (!popupsShow.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(_unref(restMoney)), 1)
                    ])
                  ]),
                  _createVNode(_unref(Button), {
                    type: "success",
                    class: _normalizeClass(_unref(canComfirm) ? 'xa-vant-button' : 'xa-vant-button-cancel'),
                    style: {"width":"140px"},
                    onClick: sumbit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("立即支付 ")
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_13
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})